import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import Wrapper from "../structure/Wrapper";

export default function Advert() {
    return(
        <section className="my-8 md:mb-12 lg:mb-20">
            <Wrapper>
                <article className="rounded-3xl overflow-hidden sm:grid sm:grid-cols-12 shadow-lg">
                    <div className="col-span-6 lg:col-span-7 max-h-200px overflow-hidden">
                        <StaticImage src="../../assets/images/AP010982.jpg" alt="Gas bottles" />
                    </div>
                    <div className="px-4 py-8 bg-grey col-span-6 lg:col-span-5 sm:flex sm:items-center">
                        <p className="text-white text-center max-w-xs mx-auto">We offer safe deliveries via a large network of over 200+ stockists in the UK. You’ll be able to access your orders and inventory information online.</p>
                    </div>
                </article>
            </Wrapper>
        </section>
    );
}